import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import config from '../config';
import moment from 'moment';
import { createAuth } from '../Helpers';

export const reducerName = 'holidayState';

export const getAllHolidays = createAsyncThunk(
    'holidayState/getAllHolidays',
    async (_, { getState, rejectWithValue }) => {
        try {
            const { startTime, endTime } = getState().plannedItemState;
            const startYear = moment(startTime).year();
            const endYear = startYear + 1;

            const response = await axios({
                method: 'GET',
                url: `${config.server}/api/Holidays`,
                withCredentials: true,
                auth: createAuth(getState),
                params: {
                    startYear,
                    endYear,
                },
            });
            return response.data;
        } catch (error) {
            console.error('ERROR FETCHING HOLIDAYS', error);
            return rejectWithValue(error.response?.data || 'An error occurred');
        }
    }
);

const initialState = {
    holidays: [],
    status: 'idle',
    error: null,
};

const holidaySlice = createSlice({
    name: reducerName,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllHolidays.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(getAllHolidays.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.holidays = action.payload || [];
            })
            .addCase(getAllHolidays.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || 'An error occurred';
            });
    },
});

export default holidaySlice.reducer;
